import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Left_Chevron: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width="12pt" height="100%" viewBox="0 0 24 24" fill={fill}>
            <Path d="M 7 5.967 C 6.623 5.968 6.279 6.181 6.11 6.517 C 5.863 7.009 6.06 7.607 6.55 7.857 L 14.76 11.967 L 6.55 16.077 C 5.839 16.373 5.715 17.327 6.327 17.795 C 6.653 18.044 7.098 18.068 7.45 17.857 L 17.45 12.857 C 18.135 12.506 18.183 11.545 17.537 11.127 C 17.509 11.109 17.48 11.092 17.45 11.077 L 7.45 6.077 C 7.312 6.003 7.157 5.965 7 5.967 Z" />
        </Svg>
    );
};

export default Left_Chevron;
